import type { FaireProductEntity } from "../../entity_types/product";

export const p_rfrbnzkggj: FaireProductEntity = {
  token: "p_rfrbnzkggj",
  type: "product",
  name: "Palo Santo 1 kilogram Premium Quality (2.2 Pounds)",
  brandToken: "b_g3nydf2am2",
  brandName: "Faiza Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/925e8472815af8bdaab29f20937085ef4941de2bced2792615be983d14e085c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d81ffb55949a562a34c090d9a18987e5cf47e58dcae13bd716798c2e3dc8bab3.jpeg",
  ],
  priceDollars: 35.95,
  description:
    "2.2 pounds (1 kg) of premium Palo Santo also known as Holy Wood sticks, which comes to approximately 4 inch pieces. Please see last listing image for specifics. \n\nImported directly from Northern Peru! We import from a sustainable source to acquire these ultra fragrant Palo Santo sticks that are always harvested from naturally fallen trees, never cut down by force. The village that farms and collects these trees are accredited by the Peruvian Government as the only environmentally cautious farm operation. \n\nHand packed and securely shipped is convenient BPA free packaging.",
  tags: [],
  msrpDollars: 71.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:30:24.542Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
